<template>
    <div>
        <div v-if="!loading" class="payment">
            <payment-methods @selectPaymentMethod="setSelected" :selectedMethod="selectedPaymentMethod" type="payment" layout="portal" :user="user"></payment-methods>
        </div>
        <div v-else>
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
  </template>
  
  <script>
  import { PaymentMethods } from '../../'
  export default {
    components: { PaymentMethods },
    props: {
        user: {
            required: true
        }
    },
    data: () => ({
        selectedPaymentMethod: -1,
        paymentMethods: null,
        loading: false
    }),
    methods: {
        setSelected(method) {
            this.selectedPaymentMethod = method
            this.$store.commit('payment/setSelectedPaymentMethod', method)
        },
    },
    beforeDestroy() {
        this.$store.commit('payment/setSelectedPaymentMethod', null)
    }
}
  </script>

  <style scoped lang="scss">
    .payment {
        padding-top: 20px;
        margin-bottom: 100px;
    }
</style>
  